import React, { Component } from 'react';
import { Container, Row, Col, Button, Table,Image, Form, DropdownButton, Dropdown, Modal,OverlayTrigger, Tooltip } from 'react-bootstrap';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import ReactNotification from 'react-notifications-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';
import JsPdf from "jspdf";
import NumberFormat from 'react-number-format';

// import { store } from 'react-notifications-component';
import InvoicesRow from './InvoicesRow';

import Connection from '../../Calls';
import Backend from '../../Backend';

import wireLogo from '../../Images/logo-wirebit-pdf.png'
import CopyClip from '../../Images/copy-clip.png';
import GAuth from '../../Images/gauth.png'
import './index.css';
import '../../style-animations.css';


var pricesSocket;

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

class InvoicesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pair_selected_dropdown: "BTC/USD",
      pair_selected: "BTCUSD",
      coin:'btc',
      paymentCoin:'',
      wallets:[],
      selectedWallet:'',
      address_pay:{},
      invoices:[],
      group_info:{},
      organization_name:'',
      selected_invoice:{},
      selected_coin:'',
      depositModal:false,
      renderWithdrawal:'request',
      amountW:'',
      passwordW:'',
      descriptionW:'Invoice Payment',
      selectedCurrency: 'btc',
      ClipboardText:'Copy to clipboard',
      idTooltip:'',
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
    }
    this.changeInfo = this.changeInfo.bind(this);
  }

  componentWillMount(){
    this.getInvoices();
    this.connectPricesSocket();
    this.availableCoins();
  }
  componentWillUnmount(){
    if(pricesSocket){
      pricesSocket.close();
      pricesSocket = null;
    }
  }
  getInvoices() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.InvoiceInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
        if(response.status.code == 0){
          this.setState({
            address_pay:response.payload.address_pay,
            invoices:response.payload.invoices,
            group_info:response.payload.group_info,
            organization_name:response.payload.group_info.organization_name,
          })
          if(response.payload.invoices[0]){
            this.getSingleInvoice(payload, response.payload.invoices[0].uuid)
          }
        }
      });

      Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), '', 1, 1000, payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            wallets: response.payload,
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });

      Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            planInfo: response.payload.plan,
            coinsInfo: response.payload.coins,
            withdrawal: response.payload.withdraw,
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });

    });
  }
  changeInfo(item){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      this.getSingleInvoice(response.payload,item.uuid)
    })
  }
  getSingleInvoice(payload,uuid){
    Backend.SingleInvoice(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01,uuid, response => {
      this.setState({
        selected_invoice:response.payload.payment,
        selected_coin:response.payload.payment.coin,
        selected_status:response.payload.status,
        selected_period:response.payload.payment_period,
        selected_uuid:uuid
      })
    })
  }
  connectPricesSocket() {
    const self = this;
    var wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    var wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
    pricesSocket = new WebSocket(wsProtocol + "//" + wsHost);
    pricesSocket.onopen = function (event) {
      pricesSocket.send('GNTWIREBIT')
    }
    pricesSocket.onmessage = function (event) {
      try {
        var object = JSON.parse(event.data);
        self.setState({
          prices: object,
        })
      } catch (e) {

      }
    }
  }
  CopyToClipboard(){
    const self=this
    self.setState({ClipboardText:'Copied to clipboard', idTooltip:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText:'Copy to clipboard',idTooltip:''}) }, 2000)

  }
// 1/this.state.prices[coin.toUpperCase() + 'USD']

  renderAddressesPayments(){
    var items =[]
    var object = this.state.address_pay

    for (var coin in object) {
      if(this.state.prices){
        var amount = this.state.group_info['cost_'+this.state.group_info.payment_subscription]
        var price = amount/this.state.prices[coin.toUpperCase()].bid
      }
      items.push(
        <tr>
          <td>
            {coin.toUpperCase()}
          </td>
          <td>

          <OverlayTrigger placement={'right'} overlay={
              <Tooltip className={this.state.idTooltip} style={{}}>
               {this.state.ClipboardText}
              </Tooltip>
            }>
            <span style={{float:'right', paddingRight:17}}>{object[coin]}
              <CopyToClipboard text={object[coin]}>
                <button className='clipboardimg' onClick={()=>{ this.CopyToClipboard()}}>
                  <Image src={CopyClip}/>
                </button>
              </CopyToClipboard>
            </span>
          </OverlayTrigger>


          </td>
          {(this.state.prices)?<td>{formatMoney(amount)} ≈ {price.toFixed(8)} {coin}</td>:<td>....</td>}
        </tr>
      )
    }
    return items;

  }

  renderAddresses(){
    var items =[]
    var object = this.state.address_pay
    for (var coin in object) {
      items.push(
        <p style={{color:'#484848'}} className='payment-addresses'>{coin.toUpperCase()}
          <span >{object[coin]}
            <CopyToClipboard text={object[coin]}>
              <button className='copy-coin-clipboard'>
                <Image src={CopyClip}/>
              </button>
            </CopyToClipboard>
          </span>
        </p>
      )
    }
    return items
  }

  renderDropwdown(){
    var object = this.state.address_pay
    var items =[]

    this.state.wallets.forEach((item, i) => {
      for (var coin in object) {
        if(item.coin === coin){
          items.push(
            <Dropdown.Item onClick={() => {this.selectWallet(item)}} as="button">
              <Image src={require("../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
              {item.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(item.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{item.coin}</label>
            </Dropdown.Item>
          )
        }
      }
    });

    return items
  }

  selectWallet(wallet){
    const self = this;

    this.state.availableCoinsArray.forEach((item, i) => {
      if(item.symbol == wallet.coin){
        this.setState({
          usdPrice: item.usd_price
        })
      }
    });
    this.setState({ selectedWallet: wallet, balanceWallet:wallet.balance, paymentCoin:wallet.coin, paymentObject:this.state.address_pay[wallet.coin]})

    if(this.state.prices ){
      var amount = this.state.group_info['cost_'+this.state.group_info.payment_subscription]
      var price = amount/this.state.prices[wallet.coin.toUpperCase()].bid
      var toPay = (price) / (1 - (this.state.planInfo.transaction_fee/100))
      this.setState({
        amountW: toPay.toFixed(8)
      })
    }
  }

  renderCoinsDropdown(){
    var items =[]
    var object = this.state.address_pay
    for (var coin in object) {
      items.push(
        <Dropdown.Item onClick={()=>this.setState({paymentCoin:coin,paymentObject:object[coin]})} as="button">
          <Image src={require("../../CryptoIcons/" + coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {coin.toUpperCase()}
        </Dropdown.Item>
      )
    }
    return items
  }

  renderPayments(){
    var items = []
    if(this.state.prices){
      var object = this.state.address_pay
      for (var coin in object) {
        var amount = this.state.group_info['cost_'+this.state.group_info.payment_subscription]
        var price = amount/this.state.prices[coin.toUpperCase()].bid
        items.push(
          <p className='payment-coin'>{coin.toUpperCase()} <span style={{float:'right'}}>{formatMoney(amount)} ≈ {price.toFixed(8)} {coin}</span></p>
        )
      }
    }
    return items
  }

  renderListInvoices() {
    const self = this;
    var users = [];
    self.state.invoices.forEach(function (row) {
      users.push(
        <InvoicesRow changeInfo={self.changeInfo} row={row} selected_uuid={self.state.selected_uuid} />
      );
    });
    return users;
  }

  BlockchainLinks(coin, tx) {
    switch (coin) {
      case "btc":
        return 'https://www.blockchain.com/en/btc/tx/' + tx; // + '/';
      case "ltc":
        return 'https://blockchair.com/litecoin/transaction/' + tx + '/';
      case "dash":
        return 'https://explorer.dash.org/insight/tx/' + tx + '/';
      case "eth":
        return 'https://etherscan.io/tx/' + tx;
      case "bch":
        return 'https://explorer.bitcoin.com/bch/tx/' + tx + '/';
      case "xrp":
        return 'https://livenet.xrpl.org/transactions/' + tx;
      case "usdt":
        return 'https://solscan.io/tx/' + tx;
      case "sol":
        return 'https://solscan.io/tx/' + tx;
      default:
        return '';
    }
  }

  render() {
    return (
      <>
        {
          ((this.state.group_info) && (this.state.group_info.cost_annual > 0 || this.state.group_info.cost_monthly > 0))
          ? <Row style={{flex:1,zIndex:2}}>
              <Col >
                <div className="container-shadow-card-wallets-information">
                  <div className='invoice-half-div'>
                      <div className='border-title-separator-container'>
                        <div className='invoices-card-titles' style={{width:'100vw'}}>
                          <p style={{float:'left'}}>Payment Invoice</p>
                          <p style={{float:'right'}}>Plan: {this.state.group_info.plan} / Deadline: {this.state.group_info.payment_deadline}</p></div>
                      </div>

                      <div>
                        {/* <p className='virtual_exchange_information_wallets_text'>Payment Addresses:</p> */}
                        <div className="invoices_dropdown" style={{display:'block', margin:0, position:'relative', textAlign:'right'}}>
                          <div style={{marginTop:8, marginRight:0, overflow:'hidden'}}>
                            {/* {this.renderAddresses()} */}
                            <table className="table table-addressinfo">
                              <tr>
                                <th>Coin</th>
                                <th>Payment Address</th>
                                <th>USD Calculator</th>
                              </tr>
                              {this.renderAddressesPayments()}
                            </table>
                          </div>
                        </div>
                        {/* <div  className='invoices-divider'/>
                        <div>
                          <p className='virtual_exchange_information_wallets_text'>USD Calculator</p>
                          {this.renderPayments()}
                        </div> */}
                        <p className='invoice-calculator-notice'>Notice: This are USD approximations using local prices <br/> Please feel free to calculate your own amounts.</p>
                      </div>
                      <Row className='pay-invoice-bottom-row' style={{marginLeft:-10,marginRight:-10}}>
                        {/* <Col md={8}>
                          <DropdownButton className="invoices_dropdown"  style={{width:'100%'}} title={(this.state.selectedWallet)?this.state.selectedWallet.alias:'Select a wallet...'}>
                            {this.renderDropwdown()}
                          </DropdownButton>
                        </Col> */}

                        <Col >
                          <Button className="save-button-invoice" style={{float:'right'}}/*disabled={this.state.selectedWallet == ''}*/ onClick={() => this.openModalDeposit()}>
                            Pay Invoice
                          </Button>
                        </Col>
                      </Row>
                        <Modal className="modal-signup-resend-email" centered aria-labelledby="contained-modal-title-vcenter" show={this.state.depositModal} onHide={() => { this.setState({depositModal:false}); }}>
                          {this.renderWithdrawal()}
                        </Modal>


                  </div>
                </div>
              </Col>
                {/* <Col lg={5}>
                  <div className='container-shadow-card-wallets-information'>
                    <p className='invoices-card-titles'>Plan information</p>
                      <p className='payment-addresses'>ORGANIZATION: <span style={{float:'right'}}>{this.state.organization_name.toUpperCase()}</span></p>
                      <p className='payment-addresses'>PLAN: <span style={{float:'right'}}>{this.state.group_info.plan}</span></p>
                      <p className='payment-addresses'>SUBSCRIPTION: <span style={{float:'right'}}>{this.state.group_info.payment_subscription}</span></p>
                      <p className='payment-addresses'>DEADLINE: <span style={{float:'right'}}>{this.state.group_info.payment_deadline}</span></p>
                      <p className='payment-addresses'>ADDRESSES: <span style={{float:'right'}}>{this.state.group_info.addresses_per_coin}</span></p>
                      <p className='payment-addresses'>PLAN WALLETS: <span style={{float:'right'}}>{this.state.group_info.wallets_per_coin}</span></p>
                      <p className='payment-addresses'>ORGANIZATION STATUS: <span className={this.state.group_info.status} style={{float:'right'}}>{this.state.group_info.status}</span></p>
                      <p className='payment-addresses'>COST: <span style={{float:'right'}}>{formatMoney(this.state.group_info['cost_' + this.state.group_info.payment_subscription])}</span></p>
                  </div>
                </Col> */}
            </Row>
          : <div></div>

        }

      </>
    );
  }

  openModalDeposit(){
    // DropdownWallets
    // if(this.state.prices && this.state.selectedWallet != ''){
    //   var amount = this.state.group_info['cost_'+this.state.group_info.payment_subscription]
    //   var price = amount/this.state.prices[this.state.selectedWallet.coin.toUpperCase() + 'USD'].bid
    //   var toPay = (price) / (1 - (this.state.planInfo.transaction_fee/100))
    //   this.setState({
    //     depositModal:true,
    //     amountW: toPay.toFixed(6)
    //   })
    // }
    if(this.state.prices){
      this.setState({
        depositModal:true,
      })
    }
  }

  sendWithdrawal() {
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (this.state.amountW !== "" && this.state.passwordW !== "" && this.state.selectedWallet != '') {
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var charly = response.payload.r01;


        Backend.Check2FA(localStorage.getItem('email'),localStorage.getItem('token'), response.payload.r01, response => {
          if (response.status.code === "0") {
            if(response.payload.status == 'enabled'){
              this.setState({renderWithdrawal:'2fa'})
            }else{
              this.sendWithdrawal2FA()
            }
          }else{
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800000,
                onScreen: true
              }
            });
            self.setState({ showLoad: false });
          }
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({ showload: false });
    }
  }

  sendWithdrawal2FA(){
    const self = this;
    // && this.state.tagIdW !== ""
    self.setState({ showload: true });

    if (this.state.amountW !== "" && this.state.passwordW !== "" && this.state.id_wallet != "") {
      let whiskas = Connection.RThzHrsb(self.state.passwordW);

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var charly = response.payload.r01;

        var amountToSend=(self.state.selectedCurrency==='usd')?self.calculateCrypto():self.state.amountW

        Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, response => {
          var code = this.state.digit1 + this.state.digit2 + this.state.digit3 + this.state.digit4 + this.state.digit5 + this.state.digit6
          Backend.WalletNewWithdrawal(localStorage.getItem('email'), localStorage.getItem('token'), this.state.selectedWallet.id_wallet, this.state.selectedWallet.coin, amountToSend, this.state.address_pay[this.state.selectedWallet.coin], "-", this.state.descriptionW, charly, response.payload.r03, code, response => {
            if (response.status.code === "0") {
              store.addNotification({
                title: "Success!",
                message: response.payload.message,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
              self.setState({
                amountW: '',
                tagIdW: '',
                descriptionW: '',
                showload: false,
                renderWithdrawal:'request',
                digit1: '',
                digit2: '',
                digit3: '',
                digit4: '',
                digit5: '',
                digit6: '',
                depositModal:false,
              });
            }else{

                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({
                  showload: false,
                  digit1: '',
                  digit2: '',
                  digit3: '',
                  digit4: '',
                  digit5: '',
                  digit6: '',
               });
               self.refs.digit_ref1.focus()
            }
          })
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({
        showload: false,
        digit1: '',
        digit2: '',
        digit3: '',
        digit4: '',
        digit5: '',
        digit6: '',
        renderWithdrawal:'request'
      });
    }
  }

  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.sendWithdrawal2FA()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

  cancelWithdrawal(){
    this.setState({
      amountW: '',
      tagIdW: '',
      descriptionW: '',
      showload: false,
      renderWithdrawal:'request',
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
      depositModal:false,
     });
  }

  receivedAmount(){
    if(this.state.amountW && this.state.planInfo) return ((this.state.amountW) * (1- (this.state.planInfo.transaction_fee/100))).toFixed(8)
  }

  calculateCrypto(){
    var calculoCrypto;
      var calculoCrypto = (this.state.amountW) / (this.state.usdPrice)
    return calculoCrypto
  }

  calculateUSD(){
    var calculoUsd;
      var calculoUsd = (this.state.amountW) * (this.state.usdPrice)
    return calculoUsd
  }

  availableCoins(){
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins( response => {
        this.setState({
          availableCoinsArray: response.payload
        })
      })

    });
  }

  renderWithdrawal(){
    switch (this.state.renderWithdrawal) {
      case 'request':
        return(
          <Modal.Body>
            <div className="border-title-separator-container">
              <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                <p className="title-container-shadow">{this.props.traductions.invoice.title}</p>
              </div>
              {/* <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">Available $10.00</p>
              </div> */}
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.invoice.L_wallet}</Form.Label>
                <Col  sm="10" className="virtual_exchange_dropdown">
                  <DropdownButton className="invoices_dropdown"  style={{width:'100%'}}
                    title={
                      (this.state.selectedWallet)
                      ?<div>
                        <Image src={require("../../CryptoIcons/" + this.state.selectedWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                        {this.state.selectedWallet.alias}
                      </div>
                      :this.props.traductions.invoice.P_wallet
                    }>
                    {this.renderDropwdown()}
                  </DropdownButton>
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.invoice.L_address}</Form.Label>
                <Col sm="10" className="virtual_exchange_dropdown">
                  <Form.Control disabled type="text" placeholder={this.props.traductions.invoice.L_address} value={this.state.address_pay[this.state.selectedWallet.coin]}  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.General.L_Amount}</Form.Label>
                  <Col sm="10">
                    <p className='text-available-modal'>{this.props.traductions.General.L_AmountAvl}: {this.state.balanceWallet} {this.state.paymentCoin}</p>
                    <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                      {
                        (this.state.selectedCurrency == 'usd')
                        ? <NumberFormat className='btc-format-input' placeholder={this.props.traductions.General.P_Amount} decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amountW: value})}} />
                      : <NumberFormat className='btc-format-input' placeholder={this.props.traductions.General.P_AmountC} decimalScale={8} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.setState({amountW: value})}} />
                      // : <Form.Control style={{ width: "100%" }} className="input-signup" type="text" placeholder="BTC Amount" value={this.state.amountW} onChange={(amountW) => { this.setState({ amountW: amountW.target.value }) }} />
                      }
                      <Button className={(this.state.selectedCurrency !== 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: this.state.paymentCoin }) }}>{this.state.paymentCoin.toUpperCase()}</Button>
                      <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                    </div>
                    <div className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error"}>
                      {
                        (this.state.selectedCurrency == 'usd')
                        ?<p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>{this.props.traductions.General.N_Amount3} {Number(this.calculateCrypto()).toFixed(8)} {this.state.paymentCoin}</p>
                        :<p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>{this.props.traductions.General.N_Amount3} {this.calculateUSD()} usd</p>
                      }
                    </div>
                  </Col>
              </Form.Group>
              {/* <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">Tag id</Form.Label>
                <Col sm="10">
                  <Form.Control className="virtual_exchange_dropdown" type="text" placeholder="Tag id" value={this.state.tagIdW} onChange={(tagIdW) => { this.setState({ tagIdW: tagIdW.target.value }) }} />
                </Col>
              </Form.Group> */}
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.invoice.L_description}</Form.Label>
                <Col sm="10" className="virtual_exchange_dropdown">
                  <Form.Control type="text" placeholder={this.props.traductions.invoice.L_description} value={this.state.descriptionW} disabled />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">{this.props.traductions.invoice.L_password}</Form.Label>
                <Col sm="10" className="virtual_exchange_dropdown">
                  <Form.Control type="password" placeholder={this.props.traductions.invoice.L_password} value={this.state.passwordW} onChange={(passwordW) => { this.setState({ passwordW: passwordW.target.value }) }} />
                </Col>
              </Form.Group>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button onClick={() => { this.sendWithdrawal() }} className="signup-button" variant="primary" disabled={this.state.showLoad}>

                {
                  (this.state.showload)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                  : this.props.traductions.invoice.btn_send
                }
              </Button>
            </div>
          </Modal.Body>
        )
        break;
      case '2fa':
        return(
          <Modal.Body>
            <div className="border-title-separator-container-left" style={{ width: "100%" }}>
              <p className="title-container-shadow">{this.props.traductions.General.TwoFa.title}</p>
            </div>
            <div className='activate-2fa-titles'>
              <div className='gauth_logo inline-block'>
                <Image src={GAuth}/>
              </div>
              <div className='inline-block'>
                <p className='password-notice'>{this.props.traductions.General.TwoFa.desc}</p>
              </div>
            </div>
            <div style={{ marginTop: 25, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Container className="container-google-autenticathor">
                <Row>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref1'
                      ref='digit_ref1'
                      maxlength='1'
                      value={this.state.digit1}
                      onChange={(digit1) => {this._handleChange(1,digit1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref2'
                      ref='digit_ref2'
                      maxlength='1'
                      value={this.state.digit2}
                      onChange={(digit2)=> {this._handleChange(2,digit2)}}
                      onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref3'
                      ref='digit_ref3'
                      maxlength='1'
                      value={this.state.digit3}
                      onChange={(digit3) => {this._handleChange(3,digit3)}}
                      onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref4'
                      ref='digit_ref4'
                      maxlength='1'
                      value={this.state.digit4}
                      onChange={(digit4) => {this._handleChange(4,digit4)}}
                      onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref5'
                      ref='digit_ref5'
                      maxlength='1'
                      value={this.state.digit5}
                      onChange={(digit5) => { this._handleChange(5,digit5)}}
                      onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
                    />
                  </Col>
                  <Col md={2}>
                    <input
                      className="form-control digits-google-autenticathor"
                      type="number"
                      name='digit_ref6'
                      ref='digit_ref6'
                      maxlength='1'
                      value={this.state.digit6}
                      onChange={(digit6) => { this._handleChange(6,digit6)}}
                      onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button className="virtual_exchange_information_wallets_text-link" variant="link" onClick={() => this.cancelWithdrawal()}>{this.props.traductions.General.TwoFa.cancel}</Button>
            </div>
          </Modal.Body>
        )
        break;
    }
  }

}

export default InvoicesIndex;
